import { AccountInfo } from "@azure/msal-browser";
import { createContext } from "react";

export const AccountInfoContext = createContext<AccountInfo | null>(null);
